import ProductShowWizard from "../pages/ProductShowWizard.svelte"

const target = document.getElementById("productShowWizard")

const props = {}

for (const attributeName in target.dataset) {
  if (attributeName.endsWith("Json")) {
    const name = attributeName.substring(0, attributeName.indexOf("Json"))
    props[name] = JSON.parse(target.dataset[attributeName])
  } else {
    props[attributeName] = target.dataset[attributeName]
  }
}

new ProductShowWizard({ target, props })
